module.exports = __webpack_public_path__ + "img/loading-1.bfb6e074.gif";